;(function () {
  'use strict'

  angular
    .module('contrast.survey')
    .controller('SurveyModalCtrl', [
      '$scope',
      '$uibModalInstance',
      'SurveyService',
      SurveyModalCtrl
    ])

  function SurveyModalCtrl($scope, $uibModalInstance, SurveyService) {
    angular.extend($scope, {
      ok: ok,
      cancel: cancel
    })

    function ok() {
      SurveyService.setCompleted().then(_dismiss)
    }

    function cancel() {
      SurveyService.setDeclined().then(_dismiss)
    }

    function _dismiss() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
